import { MenuItem } from '@mui/material';
import { FC } from 'react';
import { SMBSelect } from '../input';
import { IDropdownResponse, IPlanDropdownResponse } from '../../models';
import { alphaSort } from '../../helpers';
import { useQuery } from 'react-query';
import { getSalesLookupPlans } from '../../fetch/lookups/sales-portal';

interface ISalesPlansDropdownProps {
  value: string | number;
  handleChange: (val: string | number, neighborhoodSeriesId?: string | number) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  isRequired?: boolean;
  inputLabel?: string;
  handleClear?: () => void;
  apiParams?: any;
  isEnabled?: boolean;
}

export const SalesPlansDropdown: FC<ISalesPlansDropdownProps> = ({
  inputLabel,
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  apiParams,
  handleClear,
  isEnabled = true
}) => {
  const { isLoading: isLoadingPlans, data: plans } = useQuery<IPlanDropdownResponse[], Error>(
    ['getPlans', apiParams],
    () => getSalesLookupPlans(apiParams),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => setOptions?.(d),
      enabled: isEnabled
    }
  );

  const noPlans = !isLoadingPlans && (!plans || plans.length === 0);

  return (
    <SMBSelect
      label={isLoadingPlans ? 'Loading...' : inputLabel ?? 'Plan'}
      disabled={isDisabled || isLoadingPlans}
      name="plans"
      id="plans"
      variant="outlined"
      value={value}
      required={isRequired}
      onChange={({ target: { value } }) =>
        handleChange(
          Number(value),
          plans?.find(p => p?.value === value)?.neighborhoodSeriesId ?? undefined
        )
      }
      handleClear={() => {
        handleChange('');
        handleClear && handleClear();
      }}
      SelectProps={{
        MenuProps: {
          sx: {
            maxHeight: '30rem'
          }
        }
      }}
    >
      {!isLoadingPlans && noPlans && <MenuItem disabled>No plans available</MenuItem>}
      {!isLoadingPlans &&
        plans &&
        alphaSort(plans, 'description').map((plan, index) => {
          return (
            <MenuItem key={`${index}`} value={plan.value}>
              {plan.description}
            </MenuItem>
          );
        })}
    </SMBSelect>
  );
};
